import { useMutation } from '@tanstack/react-query';
import { updateUserMetaData } from 'shared/services/backend-api';
import { MetaData } from 'shared/types/user';

export const useUpdateUserMetaDataMutation = () =>
  useMutation({
    mutationFn: async (metadata: Partial<MetaData>) =>
      updateUserMetaData(metadata),
  });
